const EXCEL_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

const buildDownloadTimestamp = () => {
  const now = new Date()
  const pad = (value) => String(value).padStart(2, '0')

  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(
    now.getMinutes()
  )}-${pad(now.getSeconds())}`
}

const serializeFilterQueryValue = (value) => {
  if (value === null || value === undefined) {
    return ''
  }

  if (Array.isArray(value)) {
    return value.join(',')
  }

  return String(value)
}

const buildFilterQueryString = (params) => {
  return Object.keys(params)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(serializeFilterQueryValue(params[key]))}`)
    .join('&')
}

const parseBlobJsonMessage = async (blob) => {
  if (!(blob instanceof Blob)) {
    return null
  }

  try {
    const text = await blob.text()
    const parsed = JSON.parse(text)
    return parsed?.message || parsed?.data?.message || null
  } catch {
    return null
  }
}

const parseDownloadError = async (error) => {
  const blob = error?.response?.data
  if (blob instanceof Blob) {
    const message = await parseBlobJsonMessage(blob)
    if (message) {
      return message
    }
  }

  return error?.message || null
}

const assertValidExcelDownloadResponse = async (response) => {
  if (!response?.data || !(response.data instanceof Blob)) {
    throw new Error('Invalid download response')
  }

  const contentType = (response.headers?.['content-type'] || '').toLowerCase()

  if (contentType.includes('application/json') || contentType.includes('text/html')) {
    const message = await parseBlobJsonMessage(response.data)
    throw new Error(message || 'Download failed')
  }

  if (response.data.size === 0) {
    throw new Error('Downloaded file is empty')
  }
}

const downloadBlobFile = (data, filename, mimeType = EXCEL_MIME_TYPE) => {
  const blob = data instanceof Blob ? data : new Blob([data], { type: mimeType })
  const objectUrl = window.URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = objectUrl
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()

  window.URL.revokeObjectURL(objectUrl)
}

const downloadResponseFile = async (response, filename, mimeType = EXCEL_MIME_TYPE) => {
  await assertValidExcelDownloadResponse(response)
  downloadBlobFile(response.data, filename, mimeType)
}

export {
  buildDownloadTimestamp,
  buildFilterQueryString,
  downloadBlobFile,
  downloadResponseFile,
  parseDownloadError,
  EXCEL_MIME_TYPE
}
